import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"


const InstituteCard = ({ image, name, link }) => {
  return (
    <>
    <Wrapper>
     <a href={link} style={{textDecoration: 'none'}}>
      <CardBody image={image}>
        <InstituteName>
          {name}
        </InstituteName>

      </CardBody>
      </a>
    </Wrapper>
    </>
  )
}


InstituteCard.propTypes = {
  image: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired
}

// ********** Styled Components ********** //

const Wrapper = styled.div`
  overflow: hidden
`

let CardBody = styled.div`

  // Margin & Padding
  margin: 0;
  padding: var(--spacer-3) 0; // TODO Check
  
  // Positioning
  position: relative;
  
  // Sizing
  width: 100%;
  height: 100%;
  
  box-shadow: 0 0 2px rgba(0,0,0,.15),0 1px 2px rgba(0,0,0,.15);
  
  // Display
  display: flex;
  align-items: center;
  justify-content: center;
  
  // Transition
  transition: all .25s ease-in;

  // Colors
  background: linear-gradient(0deg, rgba(44, 43, 43, 0.4), rgba(44, 43, 43, 0.4)), url(${props=> props.image});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  
  // Border
  border: none;
  border-radius: 3px;
  
  
  &:hover {
    background: linear-gradient(0deg, rgba(44, 43, 43, 0.6), rgba(44, 43, 43, 0.6)), url(${props=> props.image});
    background-position: center;
    background-size: 120%;
    background-repeat: no-repeat;
    transform: scale(1.1);
  }
  
  // Large phones and below
  @media only screen and (max-width : 544px) {
    border-left: 2px solid var(--primaryRed);
    border-right: 2px solid var(--primaryRed);
  }
`

let InstituteName = styled.h2`
  
  // Margin & Padding
  margin: 0;
  padding: 0;
  
  // Font
  font-family: var(--headerFont);
  font-style: normal;
  font-weight: bold;
  font-size: var(--font-5);
  line-height: 1.25;
  letter-spacing: 1px;

  // Colors
  color: var(--textWhite);
`


export default InstituteCard
